<template>
  <div class="medication-request-related-users">
    <app-user-info :user="practitioner" :labeled="false">
      <h4><i class="fas fa-user-md" /> Datos Prescriptor</h4>
    </app-user-info>
    <app-user-info :user="patient" :labeled="false">
      <h4><i class="fas fa-user" /> Datos Paciente</h4>
    </app-user-info>
    <app-user-info v-if="hasLegalRepresentative" :user="legalRepresentative" :labeled="false">
      <h4><i class="fas fa-user" /> Datos Representante Legal</h4>
    </app-user-info>
  </div>
</template>

<script>
import AppUserInfo from '@/components/AppUserInfo';

export default {
  name: 'MedicationRequestRelatedUsers',
  components: { AppUserInfo },
  props: {
    practitioner: {
      type: Object,
      required: true
    },
    patient: {
      type: Object,
      required: true
    },
    legalRepresentative: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    hasLegalRepresentative() {
      return Object.keys(this.legalRepresentative).length > 0;
    }
  }
};
</script>

<style lang="scss">
.medication-request-related-users {
  display: flex;
  padding: $--spacing-6 0;

  .app-user-info {
    h4 {
      font-size: $--font-size-md;
    }

    &:not(:last-child) {
      border-right: 1px solid $--color-light-gray;
    }
  }
}
</style>
